(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CustomerSearch', CustomerSearch);

    CustomerSearch.$inject = ['$resource', 'ENV'];

    function CustomerSearch($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/_search/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
